import { createEffect, createEvent, createStore, sample } from 'effector'

import { fetchZendeskArticlesFromSection, type ZendeskSectionName } from './api'
import { ZendeskArticleList } from './models/ZendeskArticleList'

type ZendeskArticlesStore = {
  [key in ZendeskSectionName]?: ZendeskArticleList
}

// event
const fetchZendeskArticlesIfNeeded = createEvent<ZendeskSectionName>()

// effects
const fetchZendeskArticlesFromSectionFx = createEffect(async (sectionName: ZendeskSectionName) => {
  return await fetchZendeskArticlesFromSection(sectionName)
})

// stores
const $zendeskArticles = createStore<ZendeskArticlesStore>({})
const $zendeskArticlesLoading = fetchZendeskArticlesFromSectionFx.pending

// logic
$zendeskArticles
  .on(fetchZendeskArticlesFromSectionFx.done, (store, { params: sectionName, result }) => ({
    ...store,
    [sectionName]: new ZendeskArticleList(...result),
  }))
  .on(fetchZendeskArticlesFromSectionFx.fail, (store, { params: sectionName }) => ({
    ...store,
    [sectionName]: new ZendeskArticleList(...[]),
  }))

sample({
  clock: fetchZendeskArticlesIfNeeded,
  source: $zendeskArticles,
  filter: (zendeskArticles, sectionName) => !zendeskArticles[sectionName],
  fn: (_, sectionName) => sectionName,
  target: fetchZendeskArticlesFromSectionFx,
})

export {
  $zendeskArticles,
  $zendeskArticlesLoading,
  fetchZendeskArticlesFromSectionFx,
  fetchZendeskArticlesIfNeeded,
  type ZendeskArticlesStore,
}
